class NavbarModel {
  constructor() {
    this._customerName = '';
    this._customerSince = '';
    this._brokerageSyncId = '';
    this._tags = '';
  }

  set customerName(customerName) {
    this._customerName = customerName;
  }

  get customerName() {
    return this._customerName;
  }

  set customerSince(customerSince) {
    this._customerSince = customerSince;
  }

  get customerSince() {
    return this._customerSince;
  }

  set brokerageSyncId(brokerageSyncId) {
    this._brokerageSyncId = brokerageSyncId;
  }

  get brokerageSyncId() {
    return this._brokerageSyncId;
  }

  set tags(tags) {
    this._tags = tags;
  }

  get tags() {
    return this._tags;
  }
}

export default NavbarModel;



// WEBPACK FOOTER //
// ./client/app/shared/ui/navbar/navbar.model.js